export const GetChangePassword = "/ApplicationUser/GetChangePassword"

export const SendEmailChangePassword = "/ApplicationUser/SendEmailChangePassword"
export const SendSMSChangePassword = "/ApplicationUser/SendSMSChangePassword"

export const ChangePassword = "/ApplicationUser/ChangePassword"